import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const EASE = [0.16, 1, 0.3, 1];

const SERVICES = [
  {
    num: "01",
    title: "Weddings",
    image: "/images/g-real-moon.jpg",
    text: "Mandaps, stages, car décor and venue florals — from intimate Assamese ceremonies to grand receptions.",
  },
  {
    num: "02",
    title: "Birthdays",
    image: "/images/g-birthday.jpg",
    text: "Balloon arches, flower walls and cake-table styling that make every age feel like a milestone.",
  },
  {
    num: "03",
    title: "Engagements",
    image: "/images/g-engagement.jpg",
    text: "Romantic backdrops, ring arches and fairy-light florals for the day you say yes.",
  },
  {
    num: "04",
    title: "Corporate",
    image: "/images/g-corporate.jpg",
    text: "Stage décor, table centerpieces and entrance florals for meetings, launches and conferences.",
  },
];

export default function Services() {
  return (
    <section id="decorations" data-testid="services-section" className="border-t border-forest/10 bg-[#E8EDE9] py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: EASE }}
              className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-sage"
            >
              Event Decoration
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
              className="font-serif text-4xl font-medium tracking-tight text-forest md:text-6xl"
            >
              Celebrations we <span className="italic text-terracotta">dress</span>
            </motion.h2>
          </div>
          <motion.button
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            onClick={() => scrollToId("#contact")}
            data-testid="services-enquire-cta"
            className="group flex w-fit items-center gap-2 border-b border-forest pb-1 text-xs font-bold uppercase tracking-[0.2em] text-forest transition-colors duration-300 hover:border-marigold hover:text-marigold"
          >
            Enquire for your event
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </motion.button>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.12, ease: EASE }}
              className="group cursor-pointer"
              onClick={() => scrollToId("#contact")}
              data-testid={`service-card-${s.title.toLowerCase()}`}
            >
              <div
                className={`overflow-hidden ${
                  i % 2 === 0 ? "rounded-t-[999px]" : "rounded-none"
                } aspect-[3/4] border border-forest/15`}
              >
                <img
                  src={s.image}
                  alt={`${s.title} decoration by Utsav Flowers`}
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex items-baseline gap-3 pt-5">
                <span className="font-serif text-lg italic text-marigold">{s.num}</span>
                <h3 className="font-serif text-2xl font-medium text-forest">{s.title}</h3>
              </div>
              <p className="pt-2 text-sm leading-relaxed text-sage">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
